import { pubSub } from 'utils/pubSub';

import { SidekickActivity, SidekickQuestion } from './sidekick.types';

/**
 * Opens the Sidekick and sends a prompt as the next message. When a
 * conversation is already running, the prompt is appended to it.
 *
 * Pass a prompt to send it straight away, or a question to ask the user for
 * context first and build the prompt from their answer.
 */
export const askSidekick = (request: string | SidekickQuestion): void => {
  pubSub.publish(
    'askSidekick',
    typeof request === 'string' ? { prompt: request } : request,
  );
};

/** Opens the Sidekick and sends a prompt in a new chat. */
export const startSidekickTask = (prompt: string): void => {
  pubSub.publish('askSidekick', { prompt, newChat: true });
};

/** Opens the Sidekick without sending anything. */
export const openSidekick = (): void => {
  pubSub.publish('toggleSidekick', { isOpen: true });
};

/**
 * Tells the Sidekick something happened on the page, such as the user
 * finishing a step it asked for, and lets it respond. Ignored until the
 * Sidekick is open.
 *
 * @param text What the Sidekick reads, including how to respond.
 * @param summary What the user sees in the chat, such as "Skipped a scenario".
 */
export const notifySidekick = (text: string, summary: string): void => {
  pubSub.publish('notifySidekick', { text, summary });
};

/** Whether the Sidekick has finished its turn and needs the user to reply. */
export const isAwaitingReply = (activity: SidekickActivity): boolean =>
  activity === 'asking' || activity === 'idle';
